module.exports = __webpack_public_path__ + "static/media/il.372de789.svg";